import { isEmailValid } from '@enaratech/funnel-helper';

export const isFormattedEmailValid = (inputValue?: string) => {
  return validateAndFormatEmailInput(inputValue).isValid;
};

export const validateAndFormatEmailInput = (inputValue?: string) => {
  const value = (inputValue || '').toLowerCase();

  return { isValid: value.endsWith('@enarahealth.com') ? true : isEmailValid(value), value };
};
